import React from 'react';

import { Paper, Popper, Stack, type SxProps } from '@mui/material';
import { useCurrentBlockElement } from '@wp-block-builder/editor/hooks';

type Props = {
  placement: 'top' | 'left-start';
  children: JSX.Element[];
};
const MODIFIERS = [
  { name: 'offset', options: { offset: [0, 16] } },
  { name: 'flip', enabled: false },
  { name: 'preventOverflow', options: { altBoundary: true } },
];

export default function TuneMenuLayout({ placement, children }: Props) {
  const [anchorEl] = useCurrentBlockElement();

  if (anchorEl === null) {
    return null;
  }

  const getPaperSx = (): SxProps => {
    switch (placement) {
      case 'top':
        return { borderRadius: 64, py: 0.5, px: 1 };
      case 'left-start':
        return { borderRadius: 64, py: 1, px: 0.5 };
    }
  };

  const getDirection = () => {
    switch (placement) {
      case 'top':
        return 'row';
      case 'left-start':
        return 'column';
    }
  };
  return (
    <Popper sx={{ zIndex: 'fab' }} open anchorEl={anchorEl} placement={placement} modifiers={MODIFIERS}>
      <Paper sx={getPaperSx()} onClick={(ev) => ev.stopPropagation()}>
        <Stack direction={getDirection()}>{children}</Stack>
      </Paper>
    </Popper>
  );
}
